import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Strings from '../../Strings';
import { GET_MY_ORGS_RESULT, actions as orgFilterActions } from '../../components/OrgSelect/orgFilterActions';
import ShippingRequests from './ShippingRequests';
import TabView, { Tab } from '../../components/TabView';
import './Shipping.scss';
import ShippingOrders from './ShippingOrders';
import ShipmentsTabs from './ShipmentsTabs';
import { hasPermission, PERMISSIONS } from '../../utils/userPermissions';
import { isShipper, isSuperUser } from '../../utils/userRoles';
import PendingReturns from './PendingReturns';
import OrdersForReview from './OrdersForReview';

export const ShippingTabs = {
  PATIENTS: {
    name: Strings.shipping.patientsAwaitingKit,
    key: 'shipping-patients',
    url: '/shipping/patients',
    permissions: [PERMISSIONS.SHIPPING_PATIENTS_WITHOUT_KIT_VIEW],
  },
  PENDING_RETURNS: {
    name: Strings.shipping.devicesToReturn,
    key: 'shipping-pending-returns',
    url: '/shipping/pending-returns',
    permissions: [PERMISSIONS.SHIPPING_PENDING_RETURNS_VIEW, PERMISSIONS.SHIPPING_BULK_PENDING_RETURNS_VIEW],
  },
  SHIPPING_ORDERS: {
    name: Strings.shipping.orders,
    key: 'shipping-orders',
    url: '/shipping/orders',
    permissions: [PERMISSIONS.SHIPPING_ORDERS_VIEW, PERMISSIONS.SHIPPING_PENDING_REVIEW_ORDERS_VIEW],
  },
  SHIPMENTS: {
    name: Strings.shipping.shipments,
    key: 'shipping-shipments',
    url: '/shipping/shipments',
    permissions: [PERMISSIONS.SHIPPING_SHIPMENTS_VIEW],
  },
}
function Shipping(props) {
  const { getOrgs, activeTab } = props;

  const [orgs, setOrgs] = React.useState([]);
  const [refreshEnabled, setRefreshEnabled] = React.useState(true);
  const [refreshTimestamp, setRefreshTimestamp] = React.useState(0);

  React.useEffect(() => {
    getOrgs().then(resp => {
      if (resp?.type === GET_MY_ORGS_RESULT) {
        setOrgs(
          resp.response?.data?.map(o => {
            return { ...o, value: o.masked_id, label: o.name };
          }),
        );
      }
    });
  }, []);

  const refreshData = React.useCallback(() => {
    setRefreshEnabled(false);
    setTimeout(() => {
      setRefreshEnabled(true);
    }, 2000);
    setRefreshTimestamp(Date.now());
  }, []);

  const tabArray = React.useMemo(() => {
    const ret = [];
    Object.values(ShippingTabs).forEach(tab => {
      if ((tab.permissions && tab.permissions.some(permission => hasPermission(permission))) || isSuperUser() || isShipper()) {
        ret.push(
          <Tab
            name={tab.name}
            key={tab.key}
            path={tab.url}
          >
            {tab.key === ShippingTabs.PATIENTS.key && (
              <ShippingRequests
                orgs={orgs}
                refreshData={refreshData}
                refreshTimestamp={refreshTimestamp}
              />
            )}
            {tab.key === ShippingTabs.PENDING_RETURNS.key && <PendingReturns refreshData={refreshData} refreshTimestamp={refreshTimestamp} />}
            {tab.key === ShippingTabs.SHIPPING_ORDERS.key && hasPermission(PERMISSIONS.SHIPPING_ORDERS_VIEW) && (
              <ShippingOrders
                orgs={orgs}
                refreshData={refreshData}
                refreshTimestamp={refreshTimestamp}
              />
            )}
            {tab.key === ShippingTabs.SHIPPING_ORDERS.key && hasPermission(PERMISSIONS.SHIPPING_PENDING_REVIEW_ORDERS_VIEW) && !hasPermission(PERMISSIONS.SHIPPING_ORDERS_VIEW) && (
              <OrdersForReview
                orgs={orgs}
                refreshData={refreshData}
                refreshTimestamp={refreshTimestamp}
              />
            )}
            {tab.key === ShippingTabs.SHIPMENTS.key && (
              <ShipmentsTabs
                orgs={orgs}
                activeTab={activeTab}
                refreshData={refreshData}
                refreshTimestamp={refreshTimestamp}
              />
            )}
          </Tab>
        );
      }
    });
    return ret;
  }, [orgs, activeTab, refreshData, refreshTimestamp]);

  return (
    <TabView activeTab={activeTab} routeMode refresh={{onClick: refreshData, disabled: !refreshEnabled}}>
      {tabArray}
    </TabView>
  );
}

Shipping.propTypes = {
  getOrgs: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  getOrgs: request => dispatch(orgFilterActions.getMyOrgs(request)),
});

export default connect(null, mapDispatchToProps)(Shipping);
